module.exports = __webpack_public_path__ + "assets/bc22923089b77d56a15cb98e0890ecf0.mp3";